module.exports = __webpack_public_path__ + "assets/img/favicon/apple-icon-120x120.4d986888b30db228f2c7b5d24078f5df.png";